import React from 'react';
import app from '../../../images/cards/banner.png';
import { useViewerIsPro } from '../../../components/ads/use-viewer-pro';

/** Banner tĩnh ở cột phải. Người xem có Cab+ Pro không thấy quảng cáo, nên ẩn ngay khi biết họ có Pro. */
export const Advertisement = () => {
  const isPro = useViewerIsPro();
  const handleClick = () => {
    window.open('https://marketingagency.vn/', '_blank');
  };
  if (isPro) return null;
  return (
    <div className="relative w-full md:w-[363px] cursor-pointer" onClick={handleClick}>
      <img className="h-auto w-full  aspect-[363/488]" src={app} alt="app" />
    </div>
  );
};
